
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/reference/events/[event-id]",
      function () {
        return require("private-next-pages/docs/reference/events/[event-id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/reference/events/[event-id]"])
      });
    }
  